import { paymentRangeOptions } from '../../../data/paymentFilters'
import { DateRangeButton as SharedDateRangeButton } from '../../../components/ui/DateRangeButton'

type DateRangeButtonProps = {
  value: string
  onChange: (rangeId: string) => void
}

/** Payments toolbar wrapper around the shared date-range control. */
export const DateRangeButton = ({ value, onChange }: DateRangeButtonProps) => (
  <SharedDateRangeButton
    onChange={onChange}
    options={paymentRangeOptions}
    value={value}
  />
)
